// File: src/components/Cards/ProductCardAsyncWrapper.tsx

import React from "react";
import AsyncProductCard from "./AsyncProductCard";

export const ProductCardAsyncWrapper = ({
    product,
    onCitationClicked,
    spinnerActive,
    priceSource,
    siteId
}: {
    product: { [key: string]: any };
    onCitationClicked: (citationFilePath: string) => void;
    spinnerActive: boolean;
    priceSource: "web" | "store";
    siteId: "PUBLIC_GR" | "PUBLIC_CY";
}) => {
    const skuValue = product.sku || product.sku_id || product.skuid;
    return (
        <div
            className={`product-wrapper ${product.goldlist ? "gold-shadow" : ""} ${product.nrvlist ? "nrv-shadow" : ""}`}
            style={{ marginBottom: "24px" }}
            data-copy-product="true"
        >
            <AsyncProductCard
                sku={skuValue}
                onCitationClicked={onCitationClicked}
                spinnerActive={spinnerActive}
                benefits={product.benefits}
                priceSource={priceSource}
                siteId={siteId}
            />
        </div>
    );
};

export default ProductCardAsyncWrapper;
